document.addEventListener('click', async function (e) {
  // Ensure we are dealing with an element
  if (!e.target || !(e.target instanceof Element)) return;

  const button = e.target.closest('[name="checkout"]');
  // Also check for ID checkout just in case
  const isCheckout = button || (e.target.id === 'checkout') || e.target.closest('#checkout');

  // Refine the button reference
  const targetBtn = button || (e.target.id === 'checkout' ? e.target : e.target.closest('#checkout'));

  if (!targetBtn) return;

  e.preventDefault();
  e.stopPropagation();

  // Visual feedback could be added here (e.g. spinner on button)
  const originalText = targetBtn.innerHTML;
  // targetBtn.innerHTML = 'Validating...'; // Optional: might break layout if not careful

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Failed to fetch cart');

    const cart = await res.json();
    const productCounts = {};
    let issueProductTitle = null;

    if (cart.items && Array.isArray(cart.items)) {
      for (const item of cart.items) {
        if (!item.product_id) continue;
        const pid = item.product_id;
        productCounts[pid] = (productCounts[pid] || 0) + item.quantity;
      }

      for (const item of cart.items) {
        if (productCounts[item.product_id] >= 2) {
          issueProductTitle = item.product_title || item.title;
          break;
        }
      }
    }

    if (issueProductTitle) {
      alert(`You may only have 1 variant of ${issueProductTitle}`);
      // targetBtn.innerHTML = originalText;
      return;
    }

    // If valid, submit the form
    const formId = targetBtn.getAttribute('form');
    let form = null;
    if (formId) {
      form = document.getElementById(formId);
    } else {
      form = targetBtn.closest('form');
    }

    if (form && form instanceof HTMLFormElement) {
      // Re-submit the form safely, triggering any other event listeners.
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(targetBtn instanceof HTMLElement ? targetBtn : undefined);
      } else {
        form.submit();
      }
    } else {
      // Fallback
      window.location.href = '/checkout';
    }

  } catch (err) {
    console.error('Error validating cart:', err);
    // Proceed gracefully
    const formId = targetBtn.getAttribute('form');
    const form = formId ? document.getElementById(formId) : targetBtn.closest('form');
    if (form && form instanceof HTMLFormElement) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(targetBtn instanceof HTMLElement ? targetBtn : undefined);
      } else {
        form.submit();
      }
    }
    else window.location.href = '/checkout';
  }
});
